var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { queryAssignedElements, state } from 'lit/decorators.js';
import { sdsCustomElement } from '../../utilities/custom-components';
import { SdsTreeHeadingCell, } from '../cell/sds-tree-heading-cell.lit';
import { ColumnStructureService } from '../services/column-structure-service';
import { SdsTreeNodeBase } from './_sds-tree-node-base';
import styles from './sds-tree-heading-node.lit.scss';
/**
 *  Control that represents a heading node.
 *
 *  @slot data-heading - Slot for heading cells
 *
 *  @tag sds-tree-heading-node
 *
 * @fires `sds.tree-heading-node.border-mousedown` - Fired when the border is clicked.
 * Event is of `CustomEvent` type with details of `{x: number, borderPlacement: 'right' | 'left', targetCell: [SdsTreeHeadingCell](../cell/sds-tree-heading-cell.lit.ts), cellIndexes: number[]}` type.
 * @fires {CustomEvent<SdsTreeHeadingCellBorderMouseEvent>} `sds.tree-heading-node.border-mouseup` - Fired when the border is released,
 * Event is of `CustomEvent` type with details of `{x: number, borderPlacement: 'right' | 'left', targetCell: [SdsTreeHeadingCell](../cell/sds-tree-heading-cell.lit.ts), cellIndexes: number[]}` type.
 */
let SdsTreeHeadingNode = (() => {
    var _SdsTreeHeadingNode_childTreeCells_accessor_storage, _SdsTreeHeadingNode_nodesStyle_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-tree-heading-node')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsTreeNodeBase;
    let _childTreeCells_decorators;
    let _childTreeCells_initializers = [];
    let _childTreeCells_extraInitializers = [];
    let _nodesStyle_decorators;
    let _nodesStyle_initializers = [];
    let _nodesStyle_extraInitializers = [];
    var SdsTreeHeadingNode = _classThis = class extends _classSuper {
        get childTreeCells() { return __classPrivateFieldGet(this, _SdsTreeHeadingNode_childTreeCells_accessor_storage, "f"); }
        set childTreeCells(value) { __classPrivateFieldSet(this, _SdsTreeHeadingNode_childTreeCells_accessor_storage, value, "f"); }
        get nodesStyle() { return __classPrivateFieldGet(this, _SdsTreeHeadingNode_nodesStyle_accessor_storage, "f"); }
        set nodesStyle(value) { __classPrivateFieldSet(this, _SdsTreeHeadingNode_nodesStyle_accessor_storage, value, "f"); }
        /**
         * Start the column resizing process.
         */
        startColumnResize() {
            this.disableSelection();
        }
        /**
         * End the column resizing process.
         */
        endColumnResize() {
            this.enableSelection();
        }
        /**
         * Add a border on scroll for frozen columns.
         * @param {number} frozenColumnCount The number of frozen columns.
         */
        addBorderOnScroll(frozenColumnCount) {
            for (let index = 0; index < this.structureService.rowCount(); index++) {
                const lastFrozenCol = this.structureService.nthColumn(frozenColumnCount - 1, index);
                this.childTreeCells[lastFrozenCol].classList.add('sds-tree-cell__scroll-border');
            }
        }
        /**
         * Remove the border on scroll for frozen columns.
         * @param {number} frozenColumnCount The number of frozen columns.
         */
        removeBorderOnScroll(frozenColumnCount) {
            for (let index = 0; index < this.structureService.rowCount(); index++) {
                const lastFrozenCol = this.structureService.nthColumn(frozenColumnCount - 1, index);
                this.childTreeCells[lastFrozenCol].classList.remove('sds-tree-cell__scroll-border');
            }
        }
        /**
         * Freeze the specified number of columns.
         * @param {number} count The number of columns to freeze.
         */
        freezeColumns(count) {
            if (this.childTreeCells.length >= count) {
                this.structureService.firstNColumns(count).forEach(cell => {
                    this.childTreeCells[cell].classList.add('sds-tree-cell__frozen');
                    this.childTreeCells[cell].freeze();
                });
            }
        }
        /**
         * Unfreeze all columns.
         */
        unFreezeAllColumns() {
            this.childTreeCells.forEach(cell => cell.classList.remove('sds-tree-cell__frozen'));
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        async connectedCallback() {
            await super.connectedCallback();
            await this.updateComplete;
            this.registerCellMouseHandlers();
            this.updateColumns();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.deregisterCellMouseHandlers();
            this.structureService = ColumnStructureService.empty();
        }
        /**
         * Update the columns in the tree heading node.
         */
        updateColumns() {
            if (this.structureService === undefined) {
                this.structureService = ColumnStructureService.from(this.childTreeCells, this.columns);
            }
            else if (this.columns > 0) {
                this.structureService.updateStructure(this.childTreeCells, this.columns);
            }
        }
        async firstUpdated() {
            await this.updateComplete;
        }
        render() {
            return html `
            <div style="grid-row: 1/${this.getRowCount() + 1}"></div>
            <div style="grid-row: 1/${this.getRowCount() + 1}"></div>
            <div style="grid-row: 1/${this.getRowCount() + 1}"></div>
            <slot name="data-heading" @slotchange="${() => this.handleDataChange()}"></slot>
        `;
        }
        /**
         * Register the event handlers for cell mouse events related to column resizing.
         * Listens to `SdsTreeHeadingCell.BORDER_MOUSEUP_EVENT` and `SdsTreeHeadingCell.BORDER_MOUSEDOWN_EVENT` events
         * on each heading cell and dispatches corresponding events on the SdsTreeHeadingNode.
         */
        registerCellMouseHandlers() {
            this.resetBorderEventController();
            this.childTreeCells.forEach((cell, index) => {
                var _a;
                cell.addEventListener(SdsTreeHeadingCell.BORDER_MOUSEUP_EVENT, evnt => this.cellMouseUpHandler(this.fromToArray(this.structureService.leftmostColNumber(index), this.structureService.rightmostColNumber(index)), evnt), {
                    signal: (_a = this.borderEventController) === null || _a === void 0 ? void 0 : _a.signal,
                });
            });
            this.childTreeCells.forEach((cell, index) => {
                var _a;
                cell.addEventListener(SdsTreeHeadingCell.BORDER_MOUSEDOWN_EVENT, evnt => {
                    this.cellMouseDownHandler(evnt.detail.borderPlacement === 'left'
                        ? this.fromToArray(this.structureService.precedingLeftmostColNumber(index), this.structureService.precedingRightmostColNumber(index))
                        : this.fromToArray(this.structureService.leftmostColNumber(Math.max(0, index)), this.structureService.rightmostColNumber(Math.max(0, index))), evnt);
                }, {
                    signal: (_a = this.borderEventController) === null || _a === void 0 ? void 0 : _a.signal,
                });
            });
        }
        deregisterCellMouseHandlers() {
            var _a;
            (_a = this.borderEventController) === null || _a === void 0 ? void 0 : _a.abort();
            delete this.borderEventController;
        }
        disableSelection() {
            this.childTreeCells.forEach(cell => cell.disableSelection());
        }
        enableSelection() {
            this.childTreeCells.forEach(cell => cell.enableSelection());
        }
        resetBorderEventController() {
            var _a;
            (_a = this.borderEventController) === null || _a === void 0 ? void 0 : _a.abort();
            this.borderEventController = new AbortController();
        }
        getRowCount() {
            var _a;
            return this.structureService === undefined ? 1 : (_a = this.structureService) === null || _a === void 0 ? void 0 : _a.rowCount();
        }
        dispatchChange() {
            this.dispatchEvent(new CustomEvent(SdsTreeHeadingNode.DATA_CHANGE_EVENT, {
                bubbles: true,
                composed: true,
            }));
        }
        handleDataChange() {
            this.deregisterCellMouseHandlers();
            this.registerCellMouseHandlers();
            this.updateColumns();
            this.dispatchChange();
        }
        cellMouseUpHandler(cellIndexes, evnt) {
            this.dispatchEvent(new CustomEvent(SdsTreeHeadingNode.BORDER_MOUSEUP_EVENT, {
                bubbles: false,
                composed: false,
                detail: {
                    targetCell: evnt.target,
                    cellIndexes,
                    x: evnt.detail.x,
                    borderPlacement: evnt.detail.borderPlacement,
                },
            }));
        }
        cellMouseDownHandler(cellIndexes, evnt) {
            this.dispatchEvent(new CustomEvent(SdsTreeHeadingNode.BORDER_MOUSEDOWN_EVENT, {
                bubbles: false,
                composed: false,
                detail: {
                    targetCell: evnt.target,
                    cellIndexes,
                    x: evnt.detail.x,
                    borderPlacement: evnt.detail.borderPlacement,
                },
            }));
        }
        fromToArray(from, to) {
            const res = [];
            for (let i = 0; i < to - from + 1; i++) {
                res.push(from + i);
            }
            return res;
        }
        constructor() {
            super(...arguments);
            this.structureService = ColumnStructureService.empty();
            _SdsTreeHeadingNode_childTreeCells_accessor_storage.set(this, __runInitializers(this, _childTreeCells_initializers, void 0));
            this.borderEventController = (__runInitializers(this, _childTreeCells_extraInitializers), new AbortController());
            _SdsTreeHeadingNode_nodesStyle_accessor_storage.set(this, __runInitializers(this, _nodesStyle_initializers, { display: 'contents' }));
            __runInitializers(this, _nodesStyle_extraInitializers);
        }
    };
    _SdsTreeHeadingNode_childTreeCells_accessor_storage = new WeakMap();
    _SdsTreeHeadingNode_nodesStyle_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTreeHeadingNode");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _childTreeCells_decorators = [queryAssignedElements({
                flatten: true,
                slot: 'data-heading',
            })];
        _nodesStyle_decorators = [state()];
        __esDecorate(_classThis, null, _childTreeCells_decorators, { kind: "accessor", name: "childTreeCells", static: false, private: false, access: { has: obj => "childTreeCells" in obj, get: obj => obj.childTreeCells, set: (obj, value) => { obj.childTreeCells = value; } }, metadata: _metadata }, _childTreeCells_initializers, _childTreeCells_extraInitializers);
        __esDecorate(_classThis, null, _nodesStyle_decorators, { kind: "accessor", name: "nodesStyle", static: false, private: false, access: { has: obj => "nodesStyle" in obj, get: obj => obj.nodesStyle, set: (obj, value) => { obj.nodesStyle = value; } }, metadata: _metadata }, _nodesStyle_initializers, _nodesStyle_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTreeHeadingNode = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.DATA_CHANGE_EVENT = 'sds.tree-base-node.data-changed';
    _classThis.BORDER_MOUSEDOWN_EVENT = 'sds.tree-heading-node.border-mousedown';
    _classThis.BORDER_MOUSEUP_EVENT = 'sds.tree-heading-node.border-mouseup';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTreeHeadingNode = _classThis;
})();
export { SdsTreeHeadingNode };
